module.exports = __webpack_public_path__ + "869176de0d1a5ab3036eed5053e11016.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/NICE_banner.png
// module id = 777
// module chunks = 0